module.exports = __webpack_public_path__ + "media/images/soar/site/works_img_1-ca117b1156f2493cdfef2cdfcefdc9d3.png";